import * as base from './environment.base';

// APP_ENV marks the SSR runtime; the browser (no process) keeps the
// relative path.
const prodBffUrl = () => {
	const appEnv =
		typeof process === 'undefined' ? undefined : process.env['APP_ENV'];

	return appEnv
		? 'https://k8s.vandervalkonline.com/content-bff/v1/'
		: base.environment.apiUrl;
};

export const environment = {
	...base.environment,
	apiUrl: prodBffUrl(),
	mapboxAccessToken:
		'pk.eyJ1Ijoia29lbi12YWxrIiwiYSI6ImNtdGxidjR3dDAxOWkyd3FwMXA4eDNqNWcifQ.MjrIhVAHOp4yIAfIhk2FYw',
	production: true,
};
